import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { sendEvent } from '../../utils/gtag';

const allProjects = [
    {
    title: 'Pharmacy-Ecommerce',
    description: 'Customized Ecommerce solution for digital medicine store with inventory.',

    imageUrl: '/img/work/project3.png',
    category: 'B2B',
    caseStudyLink: '/case-studies/1',
    liveLink: 'https://www.amarosudh.com/',
  },
  {
    title: 'Training Management System',
    description: 'A comprehensive system with certification validation.',

    imageUrl: '/img/work/project5.png',
    category: 'Others',
    caseStudyLink: '/case-studies/2',
    liveLink: 'https://edge.csit.pstu.ac.bd:4040/',
  },
    {
    title: 'Institute Management System',
    description: 'Identity, Academic, Admission and Administrative implementation',

    imageUrl: '/img/work/project1.png',
    category: 'Others',
    caseStudyLink: '/case-studies/3',
    liveLink: 'https://piis.pstu.ac.bd/',
  },
  {
    title: 'Headless Ecommerce',
    description: 'Multistore state-management seamless implementations.',

    imageUrl: '/img/work/project4.png',
    category: 'B2C',
    caseStudyLink: '/case-studies/4',
    liveLink: 'https://halalmart100.com',
  },
];

const categories = ['Featured', 'B2B', 'B2C', 'Others'];

const categoryIcons = {
  Featured: (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mb-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.196-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.783-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
    </svg>
  ),
  B2B: (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mb-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  ),
  B2C: (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mb-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
    </svg>
  ),
  Others: (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mb-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
    </svg>
  ),
};

const PreviousWorksSection = () => {
  const [filter, setFilter] = useState('Featured');

  const filteredProjects = allProjects.filter(p => {
    if (filter === 'Featured') return true;
    return p.category === filter;
  });

  return (
    <section className="bg-gradient-to-tr from-black to-[#264864] py-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <p className="text-sm font-bold text-cyan-400 uppercase tracking-wider">Our Work</p>
          <h2 className="text-4xl font-bold text-white mt-2">Featured Projects</h2>
          <p className="text-gray-300 mt-4 max-w-2xl mx-auto">
            We have built a wide range of products, from complex institutional management systems to robust e-commerce platforms. Explore some of our featured projects below.
          </p>
        </div>

        <div className="flex justify-center mb-12">
          {categories.map(category => (
            <button
              key={category}
              onClick={() => setFilter(category)}
              className={`flex flex-col items-center justify-center w-36 h-24 text-sm font-medium border-l border-r border-gray-600 transition-all duration-200 ${
                filter === category
                  ? 'bg-white/5 text-cyan-400 scale-95 shadow-inner'
                  : 'bg-transparent text-gray-400 hover:bg-white/5 hover:text-white'
              }`}
            >
              {categoryIcons[category]}
              <span>{category}</span>
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {filteredProjects.length === 0 ? (
            <div className="text-center col-span-1 md:col-span-2 py-16">
                <p className="text-gray-300 text-lg">No projects in this category yet.</p>
            </div>
        ) : (
            filteredProjects.map((project, index) => (
                <div
                key={index}
                className="group relative overflow-hidden rounded-lg shadow-lg h-80 bg-cover bg-center transition-all duration-300 hover:shadow-2xl hover:shadow-cyan-400/50"
                style={{ backgroundImage: `url(${project.imageUrl})` }}
                >
                <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-70 flex flex-col items-center justify-center text-center p-6 transition-all duration-300">
                    <h3 className="text-2xl font-bold text-white mb-2">{project.title}</h3>
                    <p className="text-gray-300 mb-4">{project.description}</p>
                    <div className="flex space-x-4 mt-6">
                        <Link to={project.caseStudyLink} onClick={() => sendEvent('view_project_details', { project_title: project.title })} className="flex items-center bg-transparent border border-white text-white py-2 px-4 font-semibold hover:bg-white hover:text-black transition-all duration-300">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                            View Details
                        </Link>
                        <a href={project.liveLink} onClick={() => sendEvent('view_live_demo', { project_title: project.title })} target="_blank" rel="noopener noreferrer" className="flex items-center bg-transparent border border-white text-white py-2 px-4 font-semibold hover:bg-white hover:text-black transition-all duration-300">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                            </svg>
                            Live Demo
                        </a>
                    </div>
                </div>
                </div>
            ))
        )}
        </div>

        <div className="text-center mt-12">
            <Link to="/case-studies" onClick={() => sendEvent('view_case_studies_click')} className="bg-cyan-500 hover:bg-cyan-600 text-white font-bold py-3 px-8 rounded-full transition-colors duration-300">
                Explore More
            </Link>
        </div>
      </div>
    </section>
  );
};

export default PreviousWorksSection;